var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo=VISA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.764 7.17581L12.7071 16.8484H10.0606L8.06445 9.13064C7.94342 8.65484 7.83853 8.48064 7.46899 8.28064C6.86707 7.95484 5.87302 7.64839 5 7.45806L5.05971 7.17742H9.31992C9.86213 7.17742 10.3511 7.53871 10.4737 8.16452L11.5275 13.7613L14.1336 7.17742L16.764 7.17581ZM27.1321 13.6919C27.1434 11.1387 23.5997 10.9984 23.6239 9.85806C23.632 9.51129 23.9628 9.14194 24.6857 9.04839C25.044 9.00161 26.0332 8.96613 27.1531 9.48064L27.592 7.42903C26.9901 7.21129 26.2139 7 25.2505 7C22.7767 7 21.0339 8.31452 21.0194 10.1968C21.0032 11.5887 22.2619 12.3661 23.2108 12.829C24.1871 13.3032 24.5147 13.6081 24.5098 14.0306C24.5034 14.679 23.732 14.9661 23.0107 14.9774C21.752 14.9968 21.0226 14.6371 20.44 14.3661L19.9866 16.4855C20.5707 16.7532 21.6519 16.9871 22.7702 17C25.4038 17.0016 27.1241 15.7016 27.1321 13.6919ZM33.6677 16.85H35.9834L33.9614 7.17581H31.8248C31.3439 7.17581 30.9389 7.45484 30.7598 7.88548L27.003 16.8484H29.6318L30.153 15.4032H33.3659L33.6677 16.85ZM30.8743 13.4226L32.1927 9.79032L32.9512 13.4226H30.8743ZM20.34 7.17581L18.2696 16.8484H15.7667L17.8371 7.17581H20.34Z",
    fill: "#1434CB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 23,
    rx: 5.5,
    stroke: "#F4F6F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.badf3ed9b2c74a97d34c777f11135b82.svg";
export { ForwardRef as ReactComponent };